<!--
 * @Author: yaoyuting
 * @Date: 2019-08-28 21:44:30
 * @LastEditors: 徐艳龙 w17630400757@163.com
 * @LastEditTime: 2022-05-07 18:07:39
 * @Descripttion:
-->
<template>
  <div class="home">
    <div class="Header">
      <!-- <Header v-if="$route.meta.alive"></Header> -->
    </div>
    <div class="Main">
      <Main></Main>
    </div>
    <div class="Footer">
      <Footer v-if="$route.meta.alive"></Footer>
    </div>
  </div>
</template>

<script>
// import Header from "@/components/pc/Header";
import Main from "@/components/pc/Main";
import Footer from "@/components/pc/Footer";
export default {
 

  watch: {
  
  },
  components: {
    
    Main: Main,
    Footer: Footer,
  },
  name: "HelloWorld",
  props: {
    msg: String,
  },
};
</script>

<style scoped lang="less">
.el-menu--horizontal .el-menu {
  background-color: #fff !important;
}
body {
  text-align: center;
  background: #fdfdfd;
}

.home {
  margin: 0 auto;
  background: #fdfdfd;
  border-radius: 0px 0px 0px 0px;
}
.Header {
  width: 100%;
  background-color: rgba(0, 0, 0, 0);
}
.Main {
  width: 100%;
  background-color: #fdfdfd;
}
.Footer {
  width: 100%;
  // display: flex;
  // justify-content: center;
  background: #141414;
}
</style>
